// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605261000/js/" + chunkId + "." + {"44":"99050608","225":"c55f4f50","481":"36befb0e","486":"ff0c9754","770":"162178bf"}[chunkId] + ".0.3880881903025216.chunk.js";
};